import $ from "jquery";

export class ScrollPosition {
    private isSnapshot = false;
    private scrollPosition = {
        top: 0,
        left: 0,
        row: 0,
    };

    private dataTable: DataTables.Api;

    constructor(dataTable: DataTables.Api) {
        this.dataTable = dataTable;
    }

    public top = () => {
        this.scrollPosition.top = 0;
        this.scrollToLast();
    }
    public scrollToLast = () => {
        $(this.dataTable.settings()[0].nScrollBody).scrollTop(this.scrollPosition.top);
        $(this.dataTable.settings()[0].nScrollBody).scrollLeft(this.scrollPosition.left);
        this.isSnapshot = false;
    }

    public scrollToLastRow = () => {
        (this.dataTable as any).scroller.toPosition(this.scrollPosition.row, false);
        this.isSnapshot = false;
    }

    public freeze() {
        this.isSnapshot = true;
    }

    public storePositionOnScroll = (evt) => {
        if (!this.isSnapshot) {
            this.scrollPosition.top = evt.target.scrollTop;
            this.scrollPosition.left = evt.target.scrollLeft;
            if ((this.dataTable as any).scroller != null) {
                this.scrollPosition.row = (this.dataTable as any).scroller.page().start;
            }
        }
    }
}
